import { ReduxAction, success, failure, pending } from '../core';
import { DailyShiftSchedule, NotAllowedMatch } from './types';
import { ThunkAction } from 'redux-thunk';
import { Action, Dispatch } from 'redux';
import { HealAPI } from '../../healApi';
import { toast } from '../message/actions';

export class SchedulingAction {
  public static SET_IS_FETCHING = `SCHEDULING_SET_IS_FETCHING`;
  public static SET_SHIFTS = `SCHEDULING_SET_SHIFTS`;
  public static FETCH_PAIRING_RULES = `FETCH_PAIRING_RULES`;
  public static SET_PAIRING_RULES = `SET_PAIRING_RULES`;
}

export function setIsFetching(newValue: boolean): ReduxAction<boolean> {
  return {
    type: SchedulingAction.SET_IS_FETCHING,
    data: newValue,
  };
}

export function setShifts(shifts: DailyShiftSchedule): ReduxAction<DailyShiftSchedule> {
  return {
    type: SchedulingAction.SET_SHIFTS,
    data: shifts,
  };
}

export function fetchPairingRules(): ThunkAction<any, any, any, any> {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: pending(SchedulingAction.FETCH_PAIRING_RULES) });
    return HealAPI.getPairingRules()
      .then((response) => {
        const pairingRulesMapped: NotAllowedMatch[] = [];
        if (response && response.ok && response.data) {
          response.data.forEach((pr) => {
            pr.providerIds.forEach((pId) => {
              pairingRulesMapped.push({
                id: pr.id,
                providerOneId: pr.providerId,
                providerTwoId: pId,
                new: false,
              });
            });
          });
          dispatch({
            type: success(SchedulingAction.FETCH_PAIRING_RULES),
            data: pairingRulesMapped,
          });
        } else {
          dispatch({ type: failure(SchedulingAction.FETCH_PAIRING_RULES), data: [] });
        }
      })
      .catch((e) => {
        dispatch(
          toast({
            type: 'error',
            title: 'Error',
            content: e.error || 'An error occurred fetching provider pairing rules!',
          })
        );
        dispatch({ type: failure(SchedulingAction.FETCH_PAIRING_RULES), data: [] });
      });
  };
}
